export default "__VITE_ASSET__g9g7SiXQ__"